import Component from '../inherited/Component';
import Helpers from '../lib/Helpers';

export default class Product extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._options = {
      ...{
        historyState: true
      },
      ...this._options
    };
    this._product = this._elem.querySelector('[data-product-json]')
      ? JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML)
      : null;
    this._variantOptionTriggers = this._elem.querySelectorAll('[data-variant-option-trigger]');
    this._variant = null;
    this._sellingPlan = null;
    this._masterSelects = this._elem.querySelectorAll('[data-master-select]');
    this._priceWrappers = this._elem.querySelectorAll('[data-product-prices]');
    this._prices = this._elem.querySelectorAll('[data-price]');
    this._priceVaries = this._elem.querySelectorAll('[data-price-varies]');
    this._comparePrices = this._elem.querySelectorAll('[data-compare-price]');

    this._images = this._elem.querySelectorAll('[data-product-image]');
    this._addToCarts = this._elem.querySelectorAll('[data-submit]');
    this._addToCartHTML = Array.from(this._addToCarts).map((elem) => {
      let textElem = elem.querySelector('[data-submit-text]') || elem;
      return textElem.innerHTML;
    });

    this._productSku = this._elem.querySelector("[data-product-sku]")

    this._quantityInput = this._elem.querySelector('[data-quantity-input]');
    this._quantitySelects = this._elem.querySelectorAll('[data-quantity]');
    this._variantRadios = this._elem.querySelectorAll('[data-variant-id]');
    this._inventoryData = JSON.parse(this._elem.querySelector('[data-inventory-json]').innerHTML)
    this._inventoryAvailable = this._elem.querySelectorAll('[data-product-inventory-available]')
    this._inventoryLow = this._elem.querySelectorAll('[data-product-inventory-low]')
    this._inventoryunAvailable = this._elem.querySelectorAll('[data-product-inventory-unavailable]')

    this._extraProductsInput = this._elem.querySelector('[data-extra-products]');
    this._extraProductRadios = this._elem.querySelectorAll('[data-extra-product]');

    this._sellingPlanInput = this._elem.querySelector('[data-selling-plan]');

    this._atcAreas = this._elem.querySelectorAll('[data-atc-area]');
    this._oosAreas = this._elem.querySelectorAll('[data-oos-area]');

    this._backorderElem = this._elem.querySelector('[data-backorder]')
  }

  mount() {
    if (this._product === null) {
      return false;
    }

    this._variant = this._getVariantFromOptions();

    for (let optionSelector of this._variantOptionTriggers) {
      optionSelector.addEventListener('change', (e) => {
        this._onSelectChange();
      });
    }

    for (let optionSelector of this._variantRadios) {
      optionSelector.addEventListener('change', (e) => {
        this._onSelectChange();
      });
    }

    for (let optionSelector of this._masterSelects) {
      optionSelector.addEventListener('change', (e) => {
        this._onSelectChange();
      });
    }

    for (let optionSelector of this._extraProductRadios) {
      optionSelector.addEventListener('change', (e) => {
        this._onExtraProductRadioChange();
      });
    }

    for (let quantitySwitch of this._quantitySelects) {
      quantitySwitch.addEventListener('change', (e) => {
        if (quantitySwitch.checked) {
          this._quantityInput.value = quantitySwitch.dataset.quantity;
        }
      });
    }

    this._onSelectChange(false);

    // Shop Pay styling
    const shadowRoot = document.querySelector('shopify-payment-terms').shadowRoot;
    const style = document.createElement('style');
    style.textContent = `
      #shopify-installments {
        display: flex;
        flex-direction: column;
      }
    `;
    shadowRoot.prepend(style);
  }

  _onExtraProductRadioChange() {
    let extraProducts = [];

    for (let radio of this._extraProductRadios) {
      if (radio.checked) {
        let obj = JSON.parse(radio.dataset.extraProduct);
        extraProducts.push({
          id: obj.id,
          quantity: obj.quantity,
          selling_plan: obj.selling_plan
        });
      }
    }

    if (this._extraProductsInput) {
      this._extraProductsInput.value = JSON.stringify(extraProducts);
    }
  }

  _linkedOptions(variant) {
    for (let optionSelector of this._variantOptionTriggers) {
      optionSelector.removeAttribute('disabled');
      for (let prodVariant of this._product.variants) {
        if (
          prodVariant.option1 === variant.option1 &&
          optionSelector.value === prodVariant.option2 &&
          !prodVariant.available
        ) {
          optionSelector.setAttribute('disabled', 'disabled');
        }
      }
    }
  }

  _onSelectChange(updateImage = true) {
    let variant = this._getVariantFromOptions();

    variant.inventory = this._inventoryData.find(invVariant => invVariant.id == variant.id)

    //this._updateAddToCartState(variant);
    if (!variant) {
      return;
    }

    this._updateMasterSelect(variant);
    this._updateProductPrices(variant);
    if(updateImage) {
      this._switchToVariantImage(variant);
    }
    this._onExtraProductRadioChange();
    this._updateSellingPlan(variant);
    this._updateAtcAreas(variant);
    this._updateSku(variant);
    this._updateInventory(variant);
    this._updatePickupAvailability(variant);
    this._updateVariantElems(variant);
    this._updateOptionNames(variant);

    if(this._backorderElem) {
      this._updateBackorder(variant);
    }

    // this._linkedOptions(variant)
    this._variant = variant;

    if (this._options.historyState) {
      this._updateHistoryState(variant);
    }

    document.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        variant: this._variant
      }
    }));
  }

  _updateAtcAreas(variant) {
    for (let area of this._atcAreas) {
      if (variant.available) {
        area.classList.remove('hide');
      } else {
        area.classList.add('hide');
      }
    }

    for (let area of this._oosAreas) {
      if (variant.available) {
        area.classList.add('hide');
      } else {
        area.classList.remove('hide');
      }
    }
  }

  _updateBackorder(variant) {
    console.error(variant)
    if(variant.inventory.policy == 'continue' && variant.inventory.quantity <= 0) {
      this._backorderElem.classList.remove('hide')
    } else {
      this._backorderElem.classList.add('hide')
    }
  }

  _updateSellingPlan(variant) {
    if (!this._sellingPlanInput) return false;

    this._sellingPlanInput.value = '';
    this._sellingPlan = null;

    if (variant.selling_plan_allocations.length > 0) {
      this._sellingPlan = variant.selling_plan_allocations[0].selling_plan_id;
      this._sellingPlanInput.value = this._sellingPlan;
    }
  }

  _updatePickupAvailability(variant) {
    this.pickUpAvailability = this.pickUpAvailability || document.querySelector('pickup-availability');
    if (!this.pickUpAvailability) return;

    if (variant && variant.available) {
      this.pickUpAvailability.getAvailability(variant.id, 'pickup-availability-radiant');
    } else {
      this.pickUpAvailability.removeAttribute('available');
      this.pickUpAvailability.innerHTML = '';
    }
  }

  _updateVariantElems (variant) {
    let elems = document.querySelectorAll('[data-variant-elem]')
    for(let elem of elems) {
      let idArray = elem.dataset.variantElem.split(',');
      if (idArray.includes(variant.id.toString())) {
        elem.classList.remove('hide')
      } else {
        elem.classList.add('hide')
      }
    }
  }

  _updateOptionNames (variant) {
    let optionElems = this._elem.querySelectorAll('[data-selected-option]')
    for(let elem of optionElems) {
      let optionIndex = elem.dataset.selectedOption
      if(variant.options[optionIndex]) {
        elem.innerText = variant.options[optionIndex]
      }
    }
  }

  _updateSku (variant) {
    if(variant.sku) {
      this._productSku.querySelector('[data-variant-sku]').textContent = variant.sku
      this._productSku.classList.remove('hide')
    } else {
      this._productSku.classList.add('hide')
    }
  }

  _updateInventory(variant) {
    for (let available of this._inventoryAvailable) {
      if(variant.available && variant.inventory.quantity > variant.inventory.threshold) {
        available.classList.remove('hide')
      } else {
        available.classList.add('hide')
      }
    }
    for (let lowInventory of this._inventoryLow) {
      if(variant.inventory.quantity > 0 && variant.inventory.quantity < variant.inventory.threshold) {
        lowInventory.classList.remove('hide')
        lowInventory.querySelector('[data-text]').innerText = lowInventory.querySelector('[data-text]').dataset.text.replace('{{ quantity }}', variant.inventory.quantity)
      } else {
        lowInventory.classList.add('hide')
      }
    }
    for (let unavailable of this._inventoryunAvailable) {
      if(!variant.available || variant.inventory.quantity <= 0 && variant.inventory.policy == 'continue') {
        unavailable.classList.remove('hide')
      } else {
        unavailable.classList.add('hide')
      }
    }
  }

  _updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
      return;
    }
    let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}&view=radiant`;

    if (this._sellingPlan) {
      newurl += `&selling_plan=${this._sellingPlan}`;
    }
    window.history.replaceState({ path: newurl }, '', newurl);
  }

  _updateAddToCartState(variant) {
    if (!variant && this._product.available) {
      for (let addToCart of this._addToCarts) {
        addToCart.setAttribute('disabled', 'disabled');
        let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart;
        addToCartText.innerHTML = this._ctx.getState().locale.makeASelection;
      }
      return;
    }

    if (!variant) {
      return;
    }

    if (variant.available) {
      for (let [i, addToCart] of this._addToCarts.entries()) {
        addToCart.removeAttribute('disabled');
        let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart;
        addToCartText.innerHTML = this._addToCartHTML[i];
      }
    } else {
      for (let addToCart of this._addToCarts) {
        addToCart.setAttribute('disabled', 'disabled');
        let addToCartText = addToCart.querySelector('[data-submit-text]') || addToCart;
        addToCartText.innerHTML = this._ctx.getState().locale.soldOut;
      }
    }
  }

  _switchToVariantImage(variant) {
    for (let productImage of this._images) {
      if (productImage.dataset.variantId) {
        let idArray = productImage.dataset.variantId.split(',');
        if (idArray.includes(variant.id.toString())) {
          let mainSlider = this._theme.getComponent('mainSlider');
          let thumbnailSlider = this._theme.getComponent('thumbnailSlider');
          let index = Number(productImage.dataset.productImage) - 1;

          if (mainSlider) {
            mainSlider.component.goToSlide(index);
          }
          if (thumbnailSlider) {
            thumbnailSlider.component.goToSlide(index);
          }
        }
      }
    }
  }

  _updateProductPrices(variant) {
    for (let varies of this._priceVaries) {
      varies.classList.add('hide');
    }

    for (let productPrice of this._prices) {
      if (variant.compare_at_price > variant.price) {
        productPrice.classList.add('on-sale');
      } else {
        productPrice.classList.remove('on-sale');
      }
      productPrice.innerHTML = this._formatMoney(variant.price);
    }

    for (let productComparePrice of this._comparePrices) {
      if (variant.compare_at_price > variant.price) {
        productComparePrice.classList.remove('hide');
        productComparePrice.innerHTML = this._formatMoney(variant.compare_at_price);
      } else {
        productComparePrice.classList.add('hide');
        productComparePrice.innerHTML = '';
      }
    }
  }

  _formatMoney(price) {
    return Helpers.formatMoney(price, this._ctx.getState());
  }

  _updateMasterSelect(variant) {
    for (let originalSelector of this._masterSelects) {
      originalSelector.value = variant.id;
    }
  }

  _getCurrentOptions() {
    let currentOptions = [];
    for (let optionSelector of this._variantOptionTriggers) {
      let type = optionSelector.getAttribute('type');
      let currentOption = {};
      let alreadyDone = false;
      for (let option of currentOptions) {
        if (option.index === optionSelector.dataset.index) {
          alreadyDone = true;
        }
      }
      if (alreadyDone) continue;
      if (type === 'radio' || type === 'checkbox') {
        if (optionSelector.checked) {
          currentOption.value = optionSelector.value;
          currentOption.index = optionSelector.dataset.index;
          currentOptions.push(currentOption);
        } else {
          currentOptions.push(false);
        }
      } else {
        currentOption.value = optionSelector.value;
        currentOption.index = optionSelector.dataset.index;
        currentOptions.push(currentOption);
      }
    }
    currentOptions = Helpers.compact(currentOptions);
    return currentOptions;
  }

  _getVariantFromOptions() {
    let selectedValues = this._getCurrentOptions();
    let variants = this._product.variants;
    let found = false;

    for (let radio of this._variantRadios) {
      if (radio.checked) {
        return this._product.variants.find(
          (variant) => `${variant.id}` === radio.dataset.variantId
        );
      }
    }

    if (selectedValues.length > 0) {
      for (let variant of variants) {
        var satisfied = true;

        for (let option of selectedValues) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        }

        if (satisfied) {
          found = variant;
        }
      }
    }

    if (!found) {
      return this._product.variants.find(
        (variant) => `${variant.id}` === `${this._masterSelects[0].value}`
      );
    }

    return found || null;
  }
}
